
import React from "react";
// javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";
 

import { connect } from 'react-redux'

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

// import routes from "routes.js";
import routes from "router/allRoutes";
import Login from 'modules/auth/screens/Login';
import { AuthRequired } from 'modules/auth/components/AuthRequired';
import Cookies from 'universal-cookie';
import { authActions } from 'modules/auth/actions';
import { schoolActions } from 'modules/schools/actions';

import ReactNotification from 'react-notifications-component'

import 'react-notifications-component/dist/theme.css'

var authLib =  require ('modules/auth/authLib');
// var ps;

class Admin extends React.Component {
  
  constructor(props) {

    super(props);
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
      sidebarMini: false,  // Default to close  

      sessionCookie: this.cookies.get('sessionID'),
      currentCalendarID: this.cookies.get('calID'),
      lastLogin: this.cookies.get('lastLogin') 
    };
  }
  cookies = new Cookies();


  // checkSessionDueDate() {
  //   if (this.props && this.props.session) this.props.checkSession(this.props.session);
  // }

  componentDidMount() {
    if (this.state.sessionCookie) this.props.loadSession(this.state.sessionCookie);
    if (this.state.currentCalendarID) this.props.setCalendar(this.state.currentCalendarID);
  
    // setInterval(this.checkSessionDueDate, 2*1000);
    // if (this.props.user && !this.props.user.image) {

    // }
    
    

  }

  componentDidUpdate(e) {
    // if (e.history.action === "PUSH") {
    //   document.documentElement.scrollTop = 0;
    //   document.scrollingElement.scrollTop = 0;
    //   this.refs.mainPanel.scrollTop = 0;
    // }
  }

  
  getRoutes = (userRoles, routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(userRoles, prop.views);
      }
      if (prop.layout === "/admin") { 
        return (
          
          (authLib.authOK (userRoles, prop.roleID) ?
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key} 
          />
          :
          <Route
              path={prop.layout + prop.path}
              // component={prop.component}
              key={key}>
          <AuthRequired 
          roleID={prop.roleID} /> 
          </Route>
          )
        );
      } else {
        return null;
      }
    });
  };

  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };
  handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
    } else {
      this.setState({ sidebarMini: true });
    }
    document.body.classList.toggle("sidebar-mini");
  };

  render() {
   
    return (
      ( this.props.session && this.props.session.session_id ?
        // Logged content 
        <>
            <div className="wrapper">
              <Sidebar
                {...this.props}
                routes={routes}
                bgColor={this.state.backgroundColor}
                activeColor={this.state.activeColor}
              />
                
              <div className="main-panel" ref="mainPanel">
                <AdminNavbar {...this.props} handleMiniClick={this.handleMiniClick} />

                <ReactNotification />
                
                 <Switch>
                   {this.getRoutes(this.props.userRoles, routes)}
                  </Switch>
                <Footer fluid />
                
              </div>
            </div>
            
            </>
        :
        // Login page redirect
        <>
          <div className="wrapper wrapper-full-page" ref="fullPages">
            <div className="full-page section-image">
              <Login 
                lastLogin={this.state.lastLogin}/>
            </div>
          </div>
        </>
        )
    );
  }
}


const mapDispatchToProps = dispatch => {
  return {
    loadSession: (sessionID) => {
        dispatch(authActions.loadSession(sessionID));
      } ,
    setCalendar: (calendarID) => {
        dispatch(schoolActions.setCurrentCalendar(calendarID));
    },
    checkSession: (session) => {
      dispatch( authActions.checkSession(this.props.session) );
    }
  }
}

const mapStateToProps = state => {

  return {
    session: state.auth.session,
    user: state.auth.session.user,
    school: state.config.school,
    mainTitle: state.view.mainTitle,
    breadCrumb: state.view.breadCrumb,
    activeTitle: state.view.activeTitle,
    contextDropMenu: state.view.contextDropMenu,
    pageMenu: state.view.pageMenu,
    userRoles: state.auth.session.userRoles,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
